import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["setupGuide", "guideSection", "credentialsHint", "settingsSection", "settingField"]

  connect() {
    this.updateDisplay()
  }

  updateDisplay() {
    const select = this.element.querySelector('select[name*="destination_type"]')
    if (!select) return

    const selectedType = select.value
    this.showGuideForType(selectedType)
    this.updateCredentialHints(selectedType)
    this.updateSettingsFields(selectedType)
  }

  showGuideForType(type) {
    if (!this.hasGuideSectionTarget) return

    this.guideSectionTargets.forEach(section => {
      const sectionType = section.dataset.destinationType
      if (sectionType === type) {
        section.classList.remove("hidden")
      } else {
        section.classList.add("hidden")
      }
    })

    // Show the guide container if a type is selected
    if (this.hasSetupGuideTarget) {
      if (type && type !== "") {
        this.setupGuideTarget.classList.remove("hidden")
      } else {
        this.setupGuideTarget.classList.add("hidden")
      }
    }
  }

  updateCredentialHints(type) {
    if (!this.hasCredentialsHintTarget) return

    this.credentialsHintTargets.forEach(hint => {
      const hintTypes = (hint.dataset.forTypes || "").split(",").map(t => t.trim())
      if (hintTypes.includes(type) || hintTypes.includes("all")) {
        hint.classList.remove("hidden")
      } else {
        hint.classList.add("hidden")
      }
    })
  }

  updateSettingsFields(type) {
    // Show/hide the settings section
    if (this.hasSettingsSectionTarget) {
      // Check if any settings fields are visible for this type
      const hasVisibleFields = this.settingFieldTargets.some(field => {
        const fieldTypes = (field.dataset.forTypes || "").split(",").map(t => t.trim())
        return fieldTypes.includes(type)
      })

      if (hasVisibleFields && type) {
        this.settingsSectionTarget.classList.remove("hidden")
      } else {
        this.settingsSectionTarget.classList.add("hidden")
      }
    }

    // Show/hide individual setting fields
    if (this.hasSettingFieldTarget) {
      this.settingFieldTargets.forEach(field => {
        const fieldTypes = (field.dataset.forTypes || "").split(",").map(t => t.trim())
        if (fieldTypes.includes(type)) {
          field.classList.remove("hidden")
        } else {
          field.classList.add("hidden")
        }
      })
    }
  }

  toggleGuide(event) {
    event.preventDefault()
    const content = event.currentTarget.nextElementSibling
    const icon = event.currentTarget.querySelector('[data-icon]')

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden")
      if (icon) icon.classList.replace("fa-chevron-down", "fa-chevron-up")
    } else {
      content.classList.add("hidden")
      if (icon) icon.classList.replace("fa-chevron-up", "fa-chevron-down")
    }
  }
}
